import useContent from "@@hooks/useContent";
import useDamageRecognition from "@@pages/item-details/hooks/useDamageRecognitionContext";
import { IEditDamage } from "@@pages/item-details/schemas/ItemDamageSchema";
import getDamageScore from "@@utils/getDamageScore";
import { LayoutMervin, TableCell } from "@lux/ds";
import { useCallback } from "react";
import { Controller } from "react-hook-form";
import {
  EDamage,
  EDamageLocation,
  HardwareDamageLocationKeys,
  hardwareKeys,
} from "types/damages";
import pascalize from "utils/pascalize";
import DamageSeverityTicker from "./DamageSeverityTicker/DamageSeverityTicker";

interface IHardwareLocationDamageProps {
  name: HardwareDamageLocationKeys;
}

const HardwareLocationDamage: React.FC<IHardwareLocationDamageProps> = ({
  name,
}) => {
  const {
    content: { itemReview: content },
  } = useContent();
  const { damageMatrix, form } = useDamageRecognition();

  const handleSeverityChange = useCallback(
    (
      newValue: number | null,
      key: string,
      value: IEditDamage,
      onChange: (value: IEditDamage) => void,
    ) => {
      const damageId = Number(EDamage[pascalize(key) as unknown as number]);
      const score = getDamageScore(damageMatrix, {
        id: damageId,
        locationId: Number(
          EDamageLocation[pascalize(name) as unknown as EDamageLocation],
        ),
        severity: newValue as number,
      });
      onChange({
        ...value,
        id: damageId,
        score: score,
        severityId: newValue,
      });
    },
    [damageMatrix, name],
  );

  return (
    <TableCell colSpan={2}>
      <LayoutMervin gap='xs'>
        {hardwareKeys.map((key, index) => {
          return (
            <Controller
              control={form.control}
              key={index}
              name={`${name}.${key}`}
              render={({ field: { onChange, value, ...field } }) => {
                return (
                  <DamageSeverityTicker
                    {...field}
                    isDisabled={false}
                    label={content.damage[key]}
                    onChangeSeverity={(newValue) =>
                      handleSeverityChange(newValue, key, value, onChange)
                    }
                    value={value?.severityId ?? null}
                  />
                );
              }}
            />
          );
        })}
      </LayoutMervin>
    </TableCell>
  );
};
export default HardwareLocationDamage;
